<div class="download-asset-mode-title">
  <h1 class="title">Create Output Assets</h1>
  @if (isLoading) {
    <mat-spinner class="spinner"></mat-spinner>
  }
</div>
<mat-dialog-content class="download-asset-model">
  @if (!isLoading) {
    <div class="output-setting">
      <div class="header">
        <i class="material-icons">crop</i>
        <h3 class="title">Output Formulas</h3>
      </div>
      <mat-button-toggle-group
        class="formula-mode-toggle"
        data-testid="formula-mode-toggle"
        [value]="mode.value"
        (change)="onModeChanged($event.value)">
        <mat-button-toggle value="range">
          <mat-icon>format_list_numbered</mat-icon>
          Range
        </mat-button-toggle>
        <mat-button-toggle value="ev">
          <mat-icon>tune</mat-icon>
          EV
        </mat-button-toggle>
      </mat-button-toggle-group>
      <app-output-formula-picker
        [organizationId]="dataDialog.organizationId ?? ''"
        [mode]="mode.value"
        label="Output formulas"
        [reviewFilenamesDisabled]="isCheckFilenamesDisabled"
        (selectionChange)="onFormulaSelectionChanged($event)"
        (reviewFilenamesRequested)="checkFilenames()">
      </app-output-formula-picker>
      @if (selectedFormulaIds.length > 0 || formulaCoverageSummary !== 'Coverage: no formulas picked') {
        <div class="formula-coverage-summary">{{ formulaCoverageSummary }}</div>
      }
      <div>
        <h3 class="text-lg font-medium mb-2">Generation Options</h3>
        <mat-checkbox
          [formControl]="overwrite"
          class="custom-checkbox"
          color="primary"
          matTooltip="If checked, any existing assets of the same format will be replaced. If unchecked, only new assets will be generated."
          matTooltipPosition="after"
          >
          Overwrite Existing Assets
        </mat-checkbox>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="action">
  <span class="spacer"></span>
  <button mat-stroked-button [mat-dialog-close]="DialogResult.Cancel">Cancel</button>
  <button
    mat-stroked-button
    color="buttonSuccess"
    class="save"
    cdkFocusInitial
    [disabled]="false"
    (click)="generate()"
    >
    @if (isDownload) {
      <mat-icon
        ><mat-spinner color="accent" diameter="20"> </mat-spinner></mat-icon
        >
        }Create
      </button>
    </mat-dialog-actions>
